import { render, staticRenderFns } from "./RelatorioCancelados.vue?vue&type=template&id=f4650426"
import script from "./RelatorioCancelados.vue?vue&type=script&lang=js"
export * from "./RelatorioCancelados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports